export const GET_LOCATIONS = "User_Mini_get_locations";
export const LOCATION_LIST_SUCCESSFUL = "User_mini_locaton_list_successfull";
export const GET_SUB_LOCATIONS = "User_Mini_get_sub_locations";
export const SUB_LOCATION_LIST_SUCCESSFUL =
  "User_mini_sub_locaton_list_successfull";
export const GET_DEPARTMENT = "User_Mini_get_Department";
export const DEPARTMENT_LIST_SUCCESSFUL =
  "User_Mini_Department_list_successfull";

export const GET_USERS = "users_list";
export const USERS_LIST_SUCCESS = "users_list_success";

export const USER_ROW_DATA = "Users_Row_data";
export const USER_ROW_DATA_SUCCESS = "Users_Row_data_success";

export const GROUPS_LIST = "groups_list";
export const GROUPS_LIST_SUCCESS = "groups_list_successful";

export const PAGINATION_GROUPS_LIST = "pagination_groups_list";
export const PAGINATION_GROUPS_LIST_SUCCESS = "pagination_groups_list_successful";
export const DEPT_SELECT_FILED = "Dept_Select_Filed";
export const REMOVE_DEPT_SELECT_FILED = "Remove_Dept_Select_Filed";
export const SELECT_CHANGE_DEPT_VALUE = "Select_Change_dept_Value";
export const GET_HOD_CHECKED = "get_Hod_Cehcked";

export const LOC_SELECT_FILED = "loc_Select_Filed";
export const REMOVE_LOC_SELECT_FILED = "Remove_loc_Select_Filed";
export const SELECT_CHANGE_LOC_VALUE = "Select_Change_loc_Value";
export const MULTI_SELECT_SUBLOC_CHANGEVALUE =
  "Multi_Select_subLoc_Changevalue";

export const INPUT_CHANGEVALUE = "input_ChangeValue";
export const SELECT_CHANGEVALUE = "Select_ChangeValue";
export const MULTI_SELECT_CHANGEVALUE = "Multi_Select_ChangeValue";

export const USER_ADD = "user_add";
export const USER_ADD_SUCCESSFUL = "user_add_successful";

export const USER_EDIT = "user_Edit";
export const USER_EDIT_SUCCESSFUL = "user_edit_successful";

export const API_ERROR = "api_failed";
export const MODEL_OPEN = "users_model_open";
export const MODEL_CLOSE = "users_model_close";

export const USER_DELETE = "user_delete";
export const GROUP_ADD = "group_add";
export const GROUP_ADD_SUCCESSFUL = "group_add_successful";

export const SET_PARAMS = "users_set_params";

export const SET_PROFILE_PARAMS = "users_set_profile_params";
export const UPDATE_GROUPS_LIST = "UPDATE_GROUPS_LIST";
export const SET_PROFILE_PAGINATION_PARAMS = "SET_PROFILE_PAGINATION_PARAMS";